<template>
    <div>
        <Nav bgColor="#FFFFFF" />
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <span class="text-uppercase text-black display-header home-text mx-2 text-center">Shows</span>
            </div>
        </div>
        <div class="container pt-2">
            <div class="mx-auto text-center" style="max-width: 1000px;">
                Our main company performs two shows every Friday and Saturday night at our theater. <a class="contact-link" href ="/Contact">Click here</a> for
                directions and information on where to park. Tickets for our regular shows cost $11, $7 for students, educators and veterans,
                and can be purchased online or at the door.
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center pt-5 pb-5">
            <a :href="`${$TICKETS_URL}`">
                <div class="btn dark-btn ms-2 text-uppercase mb-5 site-black-bg text-white"
                    style="border-radius: 1; min-width: 180px;" type="button">Buy Tickets</div>
            </a>
        </div>
        <div class="bg-dark w-100 mb-5" style="height: 2px;"></div>

        <AllShows />
        <PageSections :sectionId="2" />
        <!-- <div class="container-fluid" style="background-color: black;">
         <div class="row chalk-row">
             <div class="col-md-6 offset-md-3 d-flex flex-column align-items-center justify-content-center">
                 <div class="text-center chalk-outline">
                     <div class="fs-1 text-uppercase text-white"> Take a Class</div>
                     <div class="fs-1 text-uppercase text-white"> With atlas improv</div>
                 </div>
                 <div class="text-white text-center">Atlas Improv's philosophy emphasizes character-based
                     storytelling, and, through our classes, we pass it on to our students. Besides being fun,
                     comprehensive, diverse and dynamic, our classes also build confidence, teamwork, leadership and
                     decision-making skills.</div>
                 <div class="text-white py-3 p text-center"> Every Fall, Spring, and Summer Semester, we typically
                     offer improv Core Class, Advanced Short-form and Long-form classes.</div>
                 <div class="pt-5">
                     <div class="btn ms-2 text-uppercase text-white chalk-btn "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Learn More</div>
                     <div class="btn ms-2 text-uppercase text-white chalk-btn  "
                         style="background-color: #1A95AC; border-radius: 0;" type="button">Register</div>
                 </div>

             </div>

         </div>

     </div>
     <div class="container-fluid" style="background-color:rgb(246,206,55);">
         <div class="row flex-row-reverse">
             <div class="col-md-6">
                 <div class="our-story">
                     <div class='h1 text-uppercase'> Our Story</div>
                     <div class="py-3">Atlas Improv was founded in early 2004 by Mary Parmentier and Bryan Judkins.
                         Their dream was to explore and innovate beyond what was familiar. As managers Parmentier and
                         Judkins sought a creative environment that challenged and fulfilled us artistically. They
                         knew we were capable of more and wanted to push us to new heights. They realized short-form
                         wasn’t enough. In 2004, they Started Atlas Improv. The active mebers of ComedySportz -
                         Madison followed Parmentier to do something new and amazing.</div>
                     <div class="py-3">Today Atlas Improv fosters an expert in each of its players. In story arc,
                         character building, or pure wite, every performer is a master.</div>
                     <div class="btn text-uppercase text-white chalk-btn my-5 orange-back " type="button">Learn More
                     </div>
                 </div>
             </div>
             <div class="col-md-6">
                 <img :src="`${$API_ASSETS}4b23b7c6-fb4b-44cd-bb1f-f52b097724eb.png`"
                     class="img-fluid w-100 d-md-inline" alt="globe" />
             </div>
         </div>

     </div> -->


        <div class="container-fluid position-relative pt-2 site-black-bg">
            <div class="position-relative" style="padding: 0; margin: 0;">
                <div class="text-overlay w-100 position-absolute" style="top: 20%; left: 0; padding-left: 10%;">
                    <div class="col-lg-4 text-white text-start">
                        <div class="text-uppercase display-4 oswald-bold pb-2">Other performances</div>
                        <div class="pb-3">
                            We at Atlas love sharing our stage with others. We regularly host Atlas Indie Teams as part of our 10pm shows. We have also hosted a number of local improvisers and comedians as well as visiting improvisers from out-of-town.
                        </div>
                        <div>
                            To see if we've got any of these special shows coming up, be sure to check out all our social media. If you're an improviser who will be visiting the area and would like to know more about performing on our stage or hosting a workshop, please email info@atlasimprov.com
                        </div>
                    </div>
                </div>
                <picture>
                    <source srcset="@/assets/Schoom-mobile.png" media="(max-width: 767px)" />
                    <img :src="require('@/assets/Schoom_cropped.jpeg')" class="img-fluid w-100" style="display: block; margin: 0; padding: 0;" />
                </picture>
            </div>
        </div>

        <Footer />

    </div>



</template>

<script>
import PageSections from '@/components/PageSections.vue';
import AllShows from '../components/AllShows.vue';
import Footer from '../components/Footer.vue'
import Nav from "../components/Nav.vue"
import { useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';


export default {
    name: 'Shows',
    components: {
        Nav, Footer, AllShows, PageSections
    },
    setup() {
        const route = useRoute();
        useHead({
            title: route.meta.title || 'Atlas Improv – Shows',
            meta: [
                {
                    name: 'description',
                    content: route.meta.description || 'See upcoming improv shows and buy tickets at Atlas Improv in Madison.'
                }
            ]
        });
        return {};
    },
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .text-overlay {
    position: static !important;
    padding: 3rem 2rem;
    margin-bottom: 2rem;
  }
}
</style>
